import { Core } from "@faire/design-tokens";
import { trackCategoriesSideNavigationClick } from "@faire/web-api/events/categories/click/sideNavigation";
import { INavigationTree } from "@faire/web-api/indigofair/data/INavigationTree";
import { Column } from "@faire/web/slate/Layout";
import { Typography } from "@faire/web/slate/Typography";
import { useDoActionWhenVisible } from "@faire/web/ui/hooks/useDoActionWhenVisible";
import { Link } from "@faire/web/ui/LinkAnchor";
import { assignInlineVars } from "@vanilla-extract/dynamic";
import classNames from "classnames";
import React from "react";

import {
  navigationLinkWrapper,
  navigationLinkBorderBottom,
  navigationLinkText,
  subCategoriesLinkWrapper,
} from "@faire/retailer/components/SDUI/SectionRenderers/FilterablePaginatedSection/__internal__/styles.css";
import { assignSettingOnEvent } from "@faire/retailer/settings/assignSettingOnEvent";

import INavigationTreeLink = INavigationTree.INavigationTreeLink;

export const SDUIFilterablePaginatedSectionNavigationLink: React.FC<{
  navigationTreeLink: INavigationTreeLink;
}> = ({ navigationTreeLink }) => {
  const viewRef = useDoActionWhenVisible(() => {
    navigationTreeLink.identifiers_for_assignment.forEach((setting) =>
      assignSettingOnEvent(setting)
    );
  });
  return (
    <Column align="flex-start" justify="flex-start">
      <Link
        to={navigationTreeLink.url ?? ""}
        className={classNames(navigationLinkWrapper)}
        aria-current={navigationTreeLink.selected ? "page" : undefined}
        onClick={() =>
          trackCategoriesSideNavigationClick(
            navigationTreeLink.identifier ?? ""
          )
        }
        ref={viewRef}
      >
        <Typography
          className={navigationLinkText}
          variant={
            navigationTreeLink.selected
              ? "paragraphSansMedium"
              : "paragraphSansRegular"
          }
          style={assignInlineVars({
            [navigationLinkBorderBottom]: navigationTreeLink.selected
              ? `1px solid ${Core.border.default}`
              : "1px solid transparent",
          })}
        >
          {navigationTreeLink.name ?? ""}
        </Typography>
      </Link>
      {navigationTreeLink.children.length ? (
        <ul className={subCategoriesLinkWrapper}>
          {navigationTreeLink.children.map((child) => (
            <li style={{ width: "100%" }} key={child.identifier}>
              <SDUIFilterablePaginatedSectionNavigationLink
                navigationTreeLink={child}
              />
            </li>
            // TODO(Bella): add handling to new tag
          ))}
        </ul>
      ) : null}
    </Column>
  );
};
